<template>
  <div class="animated fadeIn">
    <b-card>
      <b-form
         @submit.stop.prevent="onSubmit"
        novalidate
      >
        <b-row>
          <b-col cols="6">
              <b-form-group label="Name" label-for="name">
                  <b-form-input
                    id="name"
                    type="text"
                    :state="chkState('name')"
                    v-model.lazy.trim="$v.form.name.$model"
                    aria-describedby="liveFeedbackName"
                    placeholder="Enter Category Name"
                    autofocus
                  />
                  <b-form-invalid-feedback id="liveFeedbackName">
                    This is a required field
                  </b-form-invalid-feedback>
              </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group
              label="Parent Category"
              label-for="pcname"

            >
              <b-form-select size="md"  v-model="$v.form.pcname.$model" ref="pcname" :state="chkState('pcname')" id="pcname" name="pcname" :class="{ danger: $v.form.pcname.$error }"
                  :options="parentCatOptions" value-field="id" text-field="name">
                   <b-form-select-option :value="null">Clear Selected Option</b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Show In Catalouge?"  label-for="ismain">
            <b-form-checkbox :state="chkState('ismain')" v-model="$v.form.ismain.$model" id="ismain" name="ismain" switch>
            </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Enabled?"  label-for="enabled">
            <b-form-checkbox :state="chkState('enabled')" v-model="$v.form.enabled.$model" id="enabled" name="enabled" switch>
            </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            </b-form-select>
            <b-form-group
              label="Category Type"
              label-for="ctype"
            >
            <v-select   :options="catTypes" multiple v-model="$v.form.ctype.$model" :reduce="catTypes => catTypes.value" label="text"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="form.ctype != null && form.ctype.some(e => e.value === 'm')">
          <b-col>
            <b-form-group
              label="Meal Type"
              label-for="mealtype"
            >
              <b-form-select size="md"  v-model="$v.form.mealtype.$model" ref="mealtype" id="mealtype" name="mealtype" :class="{ danger: $v.form.mealtype.$error }"
                  :options="mealTypes" :state="chkState('mealtype')" value-field="id" text-field="name">
                   <b-form-select-option :value="null">Clear Selected Option</b-form-select-option>

              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-file
               v-model="$v.form.imagefile.$model"
               :state="chkState('imagefile')"
               placeholder="Choose a file or drop it here..."
               drop-placeholder="Drop file here..."
             >
           </b-form-file>
            <div class="mt-3">Selected file: {{ form.imagefile ? form.imagefile.name : '' }}</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
              Save
            </b-button>
          </b-col>
          <b-col>
            <b-button class="ml-1" type="reset" @click="onCancel">Close</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>


import Vue from 'vue'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import {
  mapState,
  mapActions
} from 'vuex'
import { validationMixin } from "vuelidate";
import filter from 'lodash/filter'
import { required } from "vuelidate/lib/validators";


const formShape = {
  name: null,
  pcname: null,
  ismain: null,
  ctype: [],
  mealtype: null,
  imagefile: null,
  id: null,
  systemid: null,
  isbhaint:null,
  isprasad:null,
  ismeal:null,
  enabled:null
}

export default{
  name: 'CategoryEdit',
  props: {
    systemid: {
      type: Number,
      default: null,
    },
    selectedCategory: {
      type: Object,
      default: null,
    },
    showMeal: {
      type: Boolean,
      defalut: false
    },
    showPrasad: {
      type: Boolean,
      defalut: false
    },
    showBhaint: {
      type: Boolean,
      defalut: false
    }

  },

  data: function() {
    return {
      form: Object.assign({}, formShape),
      submitted: false,
    }
  },

  validations: {
    form: {
      imagefile: {
        required: false
        },
        mealtype:{
          required: false,
        },
        ctype: {
          required: false,
        },
        ismain:{
          required
        },
        enabled:{
          required
        },
        pcname: {
          required: false
        },
        name: {
          required
        },
    }
  },

  computed: {
    parentCatOptions(){
      let systemid = this.systemid;
      let selCatId = this.selectedCategory.id;
      return filter(this.$store.state.pos.categories,
         function(cat) {
           return (cat.systemid == systemid && cat.id != selCatId);
      });
    },
    catTypes(){
      let meals = [];
      if(this.showBhaint == true)
      {
        meals.push({value:'b', text: 'Bhaint'});

      }
      if(this.showPrasad == true){
          meals.push({value:'p', text:'Prasad'});
      }

      if(this.showMeal == true){
          meals.push( {value:'m', text:'Meal'});
      }
      return meals;
    },
    mealTypes(){
      let meals = [{id:'L', name: 'Lunch'}, {id:'D', name:'Dinner'}];
      return meals;
    },

  },



  methods:{
    onCancel() {
      this.onReset();
      this.$emit('cancel')
    },
    onSubmit(){
      this.form.isprasad = false;
      this.form.ismeal = false;
      this.form.isbhaint = false;
      this.form.ctype.forEach((element) => {
        if(element.value == 'p'){
          this.form.isprasad = true;
        }
        if(element.value == 'm'){
          this.form.ismeal = true;
        }
        if(element.value == 'b'){
          this.form.isbhaint = true;
        }
      });
      if(this.validate() & this.submitted == false){
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            systemid: this.form.systemid,
            id: this.form.id,
            parentid: this.form.pcname,
            name: this.form.name,
            enabled: this.form.enabled,
            isbhaint: this.form.isbhaint,
            isprasad: this.form.isprasad,
            ismeal: this.form.ismeal,
            ismain: this.form.ismain,
            mealtype: this.form.ismeal == true? this.form.mealtype: null,
            imagefile: this.form.imagefile
          };

          this.$store
            .dispatch('pos/updateCategory', params)
            .then(response => {
              if (response.data.success == false) {
                this.showErrorMsg({
                  message: response.data.error
                })
              } else {
                this.showSuccessMsg({
                  message: 'Record updated successfully.'
                });
                this.$emit('success')
              }
              this.submitted = false;

            })
            .catch(error => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
              }
              this.submitted = false;
            })
        })

      }

    },
    validate() {
      this.$v.$touch()
      return !this.$v.form.$anyError
    },

    chkState(name){
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onReset() {
      this.form = formShape
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },


  },

  created: function(){
    if (this.$store.state.pos.categories.length == 0) {
      this.$store.dispatch('pos/getCategories');
    }

    this.form = Object.assign({}, formShape);
    this.form.ctype = [];

    this.form.name = this.selectedCategory.name;
    this.form.id = this.selectedCategory.id;
    this.form.pcname = this.selectedCategory.parentid;
    this.form.systemid = this.selectedCategory.systemid;
    this.form.ismain = this.selectedCategory.ismain == 1? true: false;
    this.form.enabled = this.selectedCategory.isEnabled == 1? true: false;
    if(this.showBhaint == true && this.selectedCategory.hasOwnProperty('isbhaint') && this.selectedCategory.isbhaint == true){
      this.form.ctype.push({value:'b', text:'Bhaint'});
      this.form.isbhaint = this.selectedCategory.isbhaint;
    }
    if(this.showPrasad == true && this.selectedCategory.hasOwnProperty('isprasad') && this.selectedCategory.isprasad == true){
      this.form.ctype.push({value:'p', text:'Prasad'});
      this.form.isprasad = this.selectedCategory.isprasad;
    }
    if(this.showMeal == true && this.selectedCategory.hasOwnProperty('ismeal') && this.selectedCategory.ismeal == true){
        this.form.ctype.push({value:'m', text:'Meal'});
        this.form.ismeal = this.selectedCategory.ismeal;
    }

    if(this.selectedCategory.hasOwnProperty('mealtype')){
        this.form.mealtype = this.selectedCategory.mealtype;
    }







  }
}
</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
